import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import * as Sentry from "@sentry/react";
import { initSentry } from "@/lib/sentry";
import "./index.css";
import App from "./App";
import { AuthProvider } from "@/auth/AuthProvider";
import { Toaster } from "@/components/ui/sonner";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 min: datos frescos, evita refetch innecesarios
      gcTime: 5 * 60_000, // 5 min: cache antes de garbage collect
      refetchOnWindowFocus: false, // evita requests al volver a la pestaña
      retry: 1, // 1 reintento en fallos de red
    },
  },
});

// Initialize Sentry (router instrumentation will be added via Sentry's automatic detection)
initSentry();

// Register service worker for PWA + Push
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("[SW] Registration failed:", err);
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider
          attribute="data-theme"
          defaultTheme="system"
          enableSystem
        >
          <AuthProvider>
            <Sentry.ErrorBoundary
              fallback={
                <p className="p-4 text-center text-destructive">
                  Algo salió mal. El equipo ha sido notificado.
                </p>
              }
            >
              <App />
            </Sentry.ErrorBoundary>
            <Toaster richColors position="top-center" />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
